let React = require("react");
let PropTypes = require("prop-types");

export const DoubleClickAd = ({ style }) => {
    // The adId needs to be at least somewhat unique so the ad doesn't get
    // loaded from a cache.
    // https://support.google.com/dcm/answer/2837459?hl=en
    // https://support.google.com/dcm/answer/2837435
    let [adId] = React.useState(Math.random() * 1000000000000000000);

    return (
        <iframe
            src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B23601142.264443108;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            height="90"
            width="728"
            // eslint-disable-next-line react/no-unknown-property
            allowtransparency="1"
            style={{ ...style, border: "none" }}
        >
            <script
                src={`https://ad.doubleclick.net/ddm/adj/N718679.3040413THENOUNPROJECT.CO/B23601142.264443108;abr=!ie;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
            />
        </iframe>
    );
};

DoubleClickAd.defaultProps = {
    style: {
        margin: "30px auto 0",
    },
};

DoubleClickAd.propTypes = {
    style: PropTypes.object,
};
